<script lang="ts">
	import { Txt } from '../../../../../components/Txt';

	interface Props {
		longDescription: string;
		dataCy: string;
	}

	let { longDescription, dataCy }: Props = $props();

	let paragraphs = $derived(longDescription.split('\n'));
</script>

{#each paragraphs as paragraph}
	<Txt data-cy={`${dataCy}-description`} variant="body1" class="mb-2 text-gray-700">
		{paragraph}
	</Txt>
{/each}
